export const materialFamilyMixin = {
  methods: {
    loadFamilyOptions() {
      let options = [];
      let allOptions = this.$store.getters.optionLists_materialFamily;
      for (let option of allOptions) {
        if (option.code !== "ac" && option.code !== "ot") {
          options.push(option);
        }
      }
      this.familyOptions = options;
    },

    listFamilyNormalizer(node) {
      return {
        id: node.code,
        label: this.getFamilyName(node.name)
      };
    },

    getFamilyName(name) {
      if (name === "Accessories") {
        name = "Accessory";
      } else if (name === "Others") {
        name = "Other";
      } else if (name === "Chamber") {
        name = "Manhole";
      }
      if (name) {
        let familyName = name.replace(/\s/g, "");
        return this.$i18n.tc(familyName, 1);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/materialFamilyMixin.js